import { Button, makeStyles, TextField, Typography, IconButton, Box, FormControl, InputLabel, Input, InputAdornment } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { member as v_member, oper as v_oper, basic, Values } from '../request/values';

import React, { Fragment, useState } from "react";
import { COLORS } from './Theme'

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CheckIcon from '@material-ui/icons/Check';
import DialogConfirm from "./Dialog";
import { useCookies } from "react-cookie";
import { SIcon } from "./Icon";

import useCommonStyles from "./commonStyles/headerEmpty/useCommonStyles";
import useFixedButtonStyles from "./commonStyles/headerEmpty/useFixedButtonStyles";

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        position: 'absolute',
        top: 0,
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    back: {
        marginLeft: '-1vh',
    },
    paper: {
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    title: {
        // width: '80%',
        alignItems: 'left'
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        "&:hover": {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        }
    },
    deleteDialogButton: {
        height: 60,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        "&:hover": {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        }
    },
    font: {
        color: `${COLORS.WATER_BLUE}`,
        fontSize: '5vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
}));

const SERVER = basic.server;


const DeleteUserAccount: React.FC<any> = props => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();
    const commonClasses = useCommonStyles();
    let history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies();

    const [deleteAccount, setDeleteAccount] = useState<any | null>();
    const [deleteDialog, setDeletDialog] = useState<boolean>(false);
    const { member, setMember, deleteMember } = props


    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;

        if (id == 'deleteAccount') setDeleteAccount(value);
    }

    const handleClose = (key: string) => {
        if (key === 'deleteDialog')
            setDeletDialog(prevState => !prevState);
    };

    const handleDeleteDialogOpen = () => {
        if (deleteAccount != "삭제") {
            enqueueSnackbar(ToastStr.DELETE_ACCOUNT_MESSAGE_FAIL_STR, { variant: "warning", translate: "no"})
        }
        else {
            setDeletDialog(true);
        }
    }

    const handleButton = async () => {
        console.log('click button')
        let url;
        if (member.type === undefined || member.type === 'member') {
            url = SERVER + v_member.member + v_member.delete
        }

        let response = await axios({
            method: "POST",
            data: {
                email: member.id,
            },
            withCredentials: true,
            url: url,
        }).then((res) => { return res.data })
            .then((data: any) => {
                console.log(data)
                if (data.code == Values.SUCCESS_CODE) {
                    return data;
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.DELETE_ACCOUNT_FAIL_STR, { variant: "warning", translate: "no" })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", translate: "no" })
                    }
                    return data;
                }
            })

        console.log('response : ', response);
        if (response.code == Values.SUCCESS_CODE) {
            console.log('Delete member is succeed')

            removeCookie("access");
            deleteMember()
            history.push('/');
        }
    }

    return (
        <>
                <div className={fixedButtonClasses.fixedButton}>
                  <IconButton onClick={() => history.goBack()}>
                      <SIcon type='Back' />
                  </IconButton>
                </div>
                <div className={commonClasses.paper}>
                    <div className={commonClasses.title}>
                        플레이스타트업 탈퇴하기
                    </div>
                    <br/>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                    >
                      <Typography className={commonClasses.desc}>
                          다음은 회원님의 계정 삭제를 확인하기 위한 절차입니다.
                      </Typography>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                    >
                    <div style={{marginBottom:'7vh'}}>
                        <Typography className={commonClasses.desc}>
                            "삭제"라고 아래 입력칸에 입력해주세요.
                        </Typography>
                    </div>
                    </Box>
                    <div className={classes.form}>
                    <TextField
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                        name="deleteAccount"
                        id="deleteAccount"
                        autoComplete="deleteAccount"
                        value={deleteAccount}
                        placeholder = "삭제"
                        InputProps={{style: {fontSize: '3vw'}}}
                        InputLabelProps={{style: {fontSize: '3vw'}}}
                        onChange={valueChangeHandler}
                        style={{ color: `${COLORS.CHARCOAL_GREY}`}}
                    />
                    <Button 
                        fullWidth
                        variant="contained"
                        onClick={() => handleDeleteDialogOpen()}
                        className={classes.deleteDialogButton}>
                        <Typography variant="h3">
                            제출하기
                        </Typography>
                    </Button>
                    </div>
                    <DialogConfirm
                        open={deleteDialog}
                        handleClose={() => handleClose('deleteDialog')}
                        title={'정말 삭제하시겠습니까?'}
                        context={''}
                        yesText='네'
                        noText='아니오'
                        yesConfirm={() => handleButton()}
                        noConfirm={() => handleClose('deleteDialog')}
                    />
                </div>
        </>

    )
}

export default DeleteUserAccount;